import { render, staticRenderFns } from "./bill-general.vue?vue&type=template&id=6ec953f8&"
import script from "./bill-general.vue?vue&type=script&lang=js&"
export * from "./bill-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports